<template>
  <footer>
    <div class="container pb-3 pb-md-0 pt-md-4 pb-md-4">
      <div class="top-footer mb-3" :class="{ 'cart-has-been-added': $store.cart.content, 'logged-in': $auth.check() }">
        <div class="top-left-footer">
          <nav>
            <ul class="nav-footer nav-list">
              <li class="nav-item">
                <router-link class="nav-link" to="/" active-class="active" exact>{{'w.footer.home'|t}}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/discover" active-class="active" exact>{{'w.footer.discover'|t}}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/book" active-class="active">{{'w.footer.book-a-room'|t}}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/blog" active-class="active">{{'w.footer.blog'|t}}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/events" active-class="active">{{'w.footer.agenda'|t}}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/contact" active-class="active">{{'w.footer.contact'|t}}</router-link>
              </li>
            </ul>
          </nav>
        </div>

        <div class="social-footer nav-list">
          <ul>
            <li><a href="https://www.facebook.com/enterthesonotron/" target="_blank" rel="noopener noreferrer" name="Facebook page"><i class="fab fa-facebook-f"></i></a></li>
            <li><a href="https://www.instagram.com/enter_the_sonotron/" target="_blank" rel="noopener noreferrer" name="Instagram page"><i class="fab fa-instagram"></i></a></li>
          </ul>
        </div>

        <div class="top-right-footer">
          <ul class="icon-nav d-flex align-items-center nav-list">
            <li class="bag" :class="{ 'cart-has-been-added': $store.cart.content }" v-if="$auth.check()"><router-link class="nav-link" to="/cart" active-class="active" exact><simple-svg :filepath="'/storage/img/icon/icon-bag.svg'" /><div class="badge-wrapper"><b-badge v-if="$store.cart.content" pill variant="success"><span>{{$store.cart.content.length}}</span></b-badge></div></router-link></li>

            <li v-if="!$auth.check()" class="profile"><router-link class="nav-link" to="/login" active-class="active" name="User account" exact><simple-svg :filepath="'/storage/img/icon/icon-profile.svg'" /></router-link></li>
            <li v-if="$auth.check()" class="profile logged-in"><router-link class="nav-link" to="/profile" active-class="active" name="User profile" exact><div class="badge-wrapper"><b-badge v-if="$store.user && $store.user.name " pill variant="success"><span>{{$store.user.name.charAt(0)}}</span><!--{{$store.user.surname.charAt(0)}}--></b-badge></div></router-link></li>
          </ul>
        </div>
      </div>

      <div class="bottom-footer justify-content-xl-between align-items-xl-center">
        <div class="bottom-left-footer d-xl-flex align-items-xl-center pb-2">
          <ul class="logo-list nav-list">
            <li><a href="https://1535.lu/" target="_blank" rel="noopener noreferrer"><b-img src="/storage/img/logo/logo-1535-v2.svg" alt="Logo 1535" /></a></li>
            <li><a href="https://www.differdange.lu/" target="_blank" rel="noopener noreferrer"><b-img src="/storage/img/logo/logo-villedifferdange.svg" class="differdange" alt="Logo Differdange" /></a></li>
            <li>
              <p>{{'w.footer.conventionne-culture'|t}}</p>
              <a href="https://mc.gouvernement.lu/fr.html" target="_blank" rel="noopener noreferrer"><b-img src="/storage/img/logo/logo-gouvernement-culture.svg" class="gov-culture" alt="Logo Luxembourgish governement culture" /></a>
            </li>
            <li><a href="https://meco.gouvernement.lu/fr.html" target="_blank" rel="noopener noreferrer"><b-img src="/storage/img/logo/logo-gouvernement-eco.svg" class="gov-eco" alt="Logo Luxembourgish governement eco" /></a></li>
          </ul>
        </div>

        <div class="bottom-right-footer">
          <nav>
            <ul class="nav-list">
              <li><router-link class="nav-link" to="/terms-of-use" active-class="active">{{'w.footer.terms-of-use'|t}}</router-link></li>
              <li><router-link class="nav-link" to="/privacy-policy" active-class="active">{{'w.footer.privacy-policy'|t}}</router-link></li>
              <li><router-link class="nav-link" to="/legal-policy" active-class="active">{{'w.footer.legal-policy'|t}}</router-link></li>
              <li><router-link class="nav-link" to="/cookies-policy" active-class="active">{{'w.footer.cookies-policy'|t}}</router-link></li>
              <li><a href="https://www.explose.lu" target="_blank" rel="noopener noreferrer" class="explose-logo"><b-img src="/storage/img/logo/logo-explose.svg" alt="Logo Explose.lu" /></a></li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </footer>

</template>

<script>

    export default {
      data() {
        return {
          year: new Date().getFullYear(),
          roles: ["Anonymous","User", "Administrator"]
        }
      },
      methods: {
        setLocale(locale) {
          this.$i18n.locale = locale
        }
      },
      computed : {
        user: function() {
          if(this.$store.user && this.$store.user.hasOwnProperty('id')) return this.$store.user;
          else return false;
        },
        locale: function() {
          return this.$i18n.locale;
        }
      },
      mounted() {

      }
    }
</script>
